<template>
    <div class="dashboard-container">
        <!-- 全站累计历史指标 -->
        <div class="history-section-wrapper">
            <div class="history-section-header">
                <h3 class="section-title">全站累计历史指标</h3>
            </div>
            <div class="history-section-card">
                <div class="history-content">
                <div class="history-left">
                    <div class="history-metrics-row">
                        <div class="history-metric" v-for="(metric, index) in historyMetrics.slice(0, 2)" :key="index">
                            <img class="metric-icon-img" :src="metric.icon" :alt="metric.label" />
                            <div class="metric-info">
                                <div class="metric-label">{{ metric.label }}</div>
                                <div class="metric-value">
                                    <span class="value-number">{{ metric.value }}</span>
                                    <span class="value-unit">{{ metric.unit }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="metrics-divider"></div>
                    <div class="history-metrics-row">
                        <div class="history-metric" v-if="historyMetrics[2]">
                            <img class="metric-icon-img" :src="historyMetrics[2].icon" :alt="historyMetrics[2].label" />
                            <div class="metric-info">
                                <div class="metric-label">{{ historyMetrics[2].label }}</div>
                                <div class="metric-value">
                                    <span class="value-number">{{ historyMetrics[2].value }}</span>
                                    <span class="value-unit">{{ historyMetrics[2].unit }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-right">
                    <div class="pie-chart-section">
                        <div class="pie-chart-title">总收入统计</div>
                        <div class="pie-chart-container">
                            <Doughnut :data="pieChartData" :options="pieChartOptions" :plugins="pieChartPlugins" />
                        </div>
                    </div>
                    <div class="revenue-stats">
                        <div class="revenue-total">
                            <div class="total-label">全站累计总收入</div>
                            <div class="total-value">
                                <span class="value-number">{{ totalRevenue.value }}</span>
                                <span class="value-unit">{{ totalRevenue.unit }}</span>
                            </div>
                        </div>
                        <div class="revenue-items">
                            <div class="revenue-item" v-for="(item, index) in revenueItems" :key="index">
                                <div class="item-left">
                                    <span class="item-dot" :style="{ backgroundColor: item.color }"></span>
                                    <span class="item-label">{{ item.label }}</span>
                                </div>
                                <div class="item-value">{{ item.value }} {{ item.unit }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>

        <div class="main-layout">
            <!-- 顶部标题栏 -->
            <div class="header-bar">
                <div class="header-left">
                    <h2 class="page-title">今日统计</h2>
                </div>
                <div class="header-right">
                    <el-select 
                        v-model="todayStation" 
                        filterable 
                        clearable
                        multiple
                        collapse-tags
                        collapse-tags-tooltip
                        placeholder="请选择场站" 
                        class="station-search"
                        style="width: 230px;"
                    >
                        <el-option 
                            v-for="station in stationList" 
                            :key="station.id" 
                            :label="station.name" 
                            :value="station.id"
                        />
                    </el-select>
                    <span class="current-time">{{ currentTime }}</span>
                    <div class="refresh-wrapper">
                        <el-icon class="refresh-icon" @click="handleRefresh">
                            <Refresh />
                        </el-icon>
                        <el-select v-model="refreshInterval" class="interval-selector" size="small">
                            <el-option label="10S" :value="10"></el-option>
                            <el-option label="15S" :value="15"></el-option>
                            <el-option label="30S" :value="30"></el-option>
                            <el-option label="60S" :value="60"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <!-- 今日统计卡片 -->
            <div class="stats-cards">
                <div class="stat-card" v-for="(card, index) in todayStats" :key="index">
                    <div class="stat-content">
                        <div class="stat-left">
                            <div class="stat-label">{{ card.label }}</div>
                            <div class="stat-value">
                                <span class="value-number">{{ card.value }}</span>
                                <span class="value-unit">{{ card.unit }}</span>
                            </div>
                            <div class="stat-footer">
                                <span class="trend-badge" :class="card.trend > 0 ? 'trend-up' : 'trend-down'">
                                    {{ card.trend > 0 ? '+' : '' }}{{ card.trend }}%
                                </span>
                                <span class="compare-value">{{ card.compareValue }}</span>
                            </div>
                        </div>
                        <div class="stat-right">
                            <img :src="getSparklineImage(index)" :class="['sparkline-image', `sparkline-${index + 1}`]" alt="trend" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 经营趋势分析 -->
            <div class="trend-analysis">
                <div class="section-header">
                    <h3 class="section-title">经营趋势分析</h3>
                    <div class="section-controls">
                        <el-select 
                            v-model="trendStation" 
                            filterable 
                            clearable
                            multiple
                            collapse-tags
                            collapse-tags-tooltip
                            placeholder="请选择场站" 
                            class="station-search"
                            style="width: 230px;"
                        >
                            <el-option
                                v-for="item in stationList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                        <el-radio-group v-model="trendPeriod" size="small" class="period-radio">
                            <el-radio-button label="日">日</el-radio-button>
                            <el-radio-button label="月">月</el-radio-button>
                            <el-radio-button label="年">年</el-radio-button>
                        </el-radio-group>
                        <el-date-picker
                            v-model="dateRange"
                            :type="datePickerType"
                            range-separator="-"
                            :start-placeholder="startPlaceholder"
                            :end-placeholder="endPlaceholder"
                            class="date-range-picker"
                            style="width: 280px;"
                            @change="handleDateRangeChange"
                        />
                    </div>
                </div>
                <div class="trend-content">
                    <div class="trend-left">
                        <div class="trend-metric" v-for="(metric, index) in trendMetrics" :key="index">
                            <div class="metric-label-row">
                                <span class="metric-dot" :style="{ backgroundColor: metric.color }"></span>
                                <span class="metric-label">{{ metric.label }}</span>
                            </div>
                            <div class="metric-value-row">
                                <span class="metric-number">{{ metric.value }}</span>
                                <span class="metric-unit">{{ metric.unit }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="trend-right">
                        <div class="trend-chart-container">
                            <Line :data="trendChartData" :options="trendChartOptions" :style="{ height: '100%' }" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 设备资产 -->
            <div class="device-assets">
                <div class="device-assets-header">
                    <h3 class="section-title">设备资产</h3>
                    <el-select 
                        v-model="deviceAssetStation" 
                        filterable 
                        clearable
                        multiple
                        collapse-tags
                        collapse-tags-tooltip
                        placeholder="请选择场站" 
                        class="station-search"
                        style="width: 230px;"
                    >
                        <el-option
                            v-for="item in stationList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        />
                    </el-select>
                </div>
                <div class="device-assets-content">
                    <div class="asset-left-panel">
                        <div class="pile-icon-wrapper">
                            <img src="https://echarging.oss-cn-guangzhou.aliyuncs.com/new_mini/pile.png" alt="充电桩" class="pile-icon" />
                        </div>
                        <div class="gauge-section">
                            <div class="utilization-gauge">
                                <svg viewBox="0 0 100 60" class="gauge-svg">
                                    <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="#e4e7ed" stroke-width="8" stroke-linecap="round" />
                                    <path d="M 10 50 A 40 40 0 0 1 90 50" fill="none" stroke="#0FBC90" stroke-width="8" stroke-linecap="round" :stroke-dasharray="`${avgUtilizationRate * 1.26} 126`" />
                                </svg>
                                <span class="utilization-text">{{ avgUtilizationRate }}%</span>
                            </div>
                            <span class="utilization-label">加权平均利用率</span>
                        </div>
                    </div>
                    <div class="asset-center-panel">
                        <div class="panel-body">
                            <div class="panel-left">
                                <div class="panel-title">慢充设备总数</div>
                                <div class="panel-total">
                                    <span class="total-number">{{ slowTotalCount }}</span>
                                    <span class="total-unit">台</span>
                                </div>
                                <span class="circle-label">慢充利用率</span>
                                <div class="utilization-gauge-chart" ref="slowUtilizationChart"></div>
                            </div>
                            <img src="@/assets/images/index/device_line.png" alt="分割线" class="divider-line" />
                            <div class="panel-right">
                                <div class="device-stats-grid">
                                    <div class="stat-row" v-for="(item, index) in slowDevices" :key="index" :class="{ 'clickable': item.label === '故障' || item.label === '离线' }" @click="handleDeviceAlarmClick(item.label)">
                                        <div class="stat-info">
                                            <span class="stat-label">{{ item.label }} {{ item.count }}台</span>
                                            <span class="stat-percent">{{ item.percentage }}%</span>
                                        </div>
                                        <div class="stat-progress">
                                            <el-progress :percentage="item.percentage" :color="item.color" :show-text="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="asset-right-panel">
                        <div class="panel-body">
                            <div class="panel-left">
                                <div class="panel-title">快充设备总数</div>
                                <div class="panel-total">
                                    <span class="total-number">{{ fastTotalCount }}</span>
                                    <span class="total-unit">台</span>
                                </div>
                                <span class="circle-label">快充利用率</span>
                                <div class="utilization-gauge-chart" ref="fastUtilizationChart"></div>
                            </div>
                            <img src="@/assets/images/index/device_line.png" alt="分割线" class="divider-line" />
                            <div class="panel-right">
                                <div class="device-stats-grid">
                                    <div class="stat-row" v-for="(item, index) in fastDevices" :key="index" :class="{ 'clickable': item.label === '故障' || item.label === '离线' }" @click="handleDeviceAlarmClick(item.label)">
                                        <div class="stat-info">
                                            <span class="stat-label">{{ item.label }} {{ item.count }}台</span>
                                            <span class="stat-percent">{{ item.percentage }}%</span>
                                        </div>
                                        <div class="stat-progress">
                                            <el-progress :percentage="item.percentage" :color="item.color" :show-text="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 场站数据明细 -->
        <div class="station-detail-section">
            <div class="section-header">
                <h3 class="section-title">场站数据明细</h3>
                <span class="station-count">共 {{ stationDetailTotal }} 个场站</span>
                <div class="search-wrapper">
                    <el-select 
                        v-model="stationSearchIds" 
                        filterable 
                        clearable
                        multiple
                        collapse-tags
                        collapse-tags-tooltip
                        placeholder="请选择场站" 
                        class="station-search"
                        style="width: 230px;"
                    >
                        <el-option
                            v-for="item in stationList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                    <el-date-picker
                        v-model="stationDateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="YYYY-MM-DD"
                        class="station-date-picker"
                    />
                </div>
            </div>
            <div class="station-table-wrapper">
                <el-table 
                    :data="stationDetailList" 
                    v-loading="stationDetailLoading"
                    stripe
                    style="width: 100%"
                    :header-cell-style="{ background: '#fafafa', color: '#606266', fontWeight: '500' }"
                >
                    <el-table-column label="排名" width="60" align="center">
                        <template #default="{ $index }">
                            <span class="rank-badge" :class="`rank-${$index + 1}`">{{ $index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="stationName" label="场站名称" min-width="150" show-overflow-tooltip />
                    <el-table-column prop="openTime" label="开业日期" width="110">
                        <template #default="{ row }">{{ formatDate(row.openTime) }}</template>
                    </el-table-column>
                    <el-table-column prop="connectorCount" label="枪数" width="80" align="center" />
                    <el-table-column prop="operationsDays" label="运营天数" width="100" align="center" />
                    <el-table-column label="慢充指标" align="center">
                        <el-table-column prop="slowIndicator.dailyChargeElec" label="单车日均(kWh)" width="120" align="center" />
                        <el-table-column prop="slowIndicator.avgElec" label="单站日均(kWh)" width="120" align="center" />
                        <el-table-column prop="slowIndicator.connectorAvgElec" label="单枪日均(kWh)" width="120" align="center" />
                    </el-table-column>
                    <el-table-column label="快充指标" align="center">
                        <el-table-column prop="fastIndicator.dailyChargeElec" label="单车日均(kWh)" width="120" align="center" />
                        <el-table-column prop="fastIndicator.avgElec" label="单站日均(kWh)" width="120" align="center" />
                        <el-table-column prop="fastIndicator.connectorAvgElec" label="单枪日均(kWh)" width="120" align="center" />
                    </el-table-column>
                    <el-table-column label="日均用户数" width="110" align="center">
                        <template #default="{ row }">{{ row.avgUserDayCount }}</template>
                    </el-table-column>
                    <el-table-column label="周期收益(元)" width="120" align="right">
                        <template #default="{ row }">
                            <span class="revenue-text">{{ formatNumber(row.avgMonthAmt) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="累计收益(元)" width="120" align="right">
                        <template #default="{ row }">
                            <span class="revenue-text total-revenue">{{ formatNumber(row.totalAmt) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrapper">
                    <el-pagination
                        v-model:current-page="stationDetailPage"
                        v-model:page-size="stationDetailPageSize"
                        :page-sizes="[10, 20, 50, 100]"
                        :total="stationDetailTotal"
                        layout="total, prev, pager, next"
                        @current-change="handleStationPageChange"
                        @size-change="handleStationSizeChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Refresh, Search } from '@element-plus/icons-vue';
import service from '@/config/axios';
import { Line, Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale, ArcElement } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale, ArcElement);

// 全局定时器管理
let globalRefreshTimer = null;
let globalRefreshInterval = 10;
let isTimerRunning = false;

function startGlobalRefresh(fetchFn) {
    if (globalRefreshTimer) {
        clearInterval(globalRefreshTimer);
        globalRefreshTimer = null;
    }
    
    isTimerRunning = true;
    globalRefreshTimer = setInterval(() => {
        if (!isTimerRunning) return;
        fetchFn();
    }, globalRefreshInterval * 1000);
}

function stopGlobalRefresh() {
    isTimerRunning = false;
}

export default {
    name: 'Index',
    components: {
        Refresh,
        Search,
        Line,
        Doughnut
    },
    data() {
        return {
            currentTime: '',
            todayStation: [],
            refreshInterval: 10,
            trendPeriod: '日',
            dateRange: [],
            isFetchingTrends: false,
            isComponentActive: true,
            refreshTimerId: null,
            todayStats: [
                { label: '今日总收入', value: '0.00', unit: '元', trend: 0, compareValue: '0' },
                { label: '今日电费收入', value: '0.00', unit: '元', trend: 0, compareValue: '0' },
                { label: '今日服务费收入', value: '0.00', unit: '元', trend: 0, compareValue: '0' },
                { label: '今日充电量', value: '0.00', unit: 'kWh', trend: 0, compareValue: '0' },
                { label: '单枪充电量', value: '0.00', unit: 'kWh', trend: 0, compareValue: '0' },
                { label: '今日毛利润', value: '0.00', unit: '元', trend: 0, compareValue: '0' },
                { label: '今日充电车次', value: '0', unit: '辆', trend: 0, compareValue: '0' },
            ],
            trendMetrics: [
                { label: '合计充电量', value: '0.00', unit: 'kwh', color: '#52c41a' },
                { label: '合计服务费', value: '0.00', unit: '元', color: '#faad14' },
                { label: '合计毛利润', value: '0.00', unit: '元', color: '#f5222d' },
            ],
            fastDevices: [
                { label: '充电', count: 0, percentage: 0, color: '#52c41a' },
                { label: '空闲', count: 0, percentage: 0, color: '#faad14' },
                { label: '故障', count: 0, percentage: 0, color: '#f5222d' },
                { label: '离线', count: 0, percentage: 0, color: '#d9d9d9' },
            ],
            slowDevices: [
                { label: '充电', count: 0, percentage: 0, color: '#52c41a' },
                { label: '空闲', count: 0, percentage: 0, color: '#faad14' },
                { label: '故障', count: 0, percentage: 0, color: '#f5222d' },
                { label: '离线', count: 0, percentage: 0, color: '#d9d9d9' },
            ],
            fastTotalCount: 0,
            slowTotalCount: 0,
            avgUtilizationRate: 0,
            fastUtilization: 0,
            slowUtilization: 0,
            slowUtilizationChart: null,
            fastUtilizationChart: null,
            deviceAssetStation: [],
            trendStation: [],
            historyMetrics: [
                { label: '全站累计总充电量', value: '0', unit: 'kwh', icon: require('@/assets/images/index/total_1.png') },
                { label: '全站累计毛利润', value: '0', unit: '万元', icon: require('@/assets/images/index/total_2.png') },
                { label: '全站累计充电总车次', value: '0', unit: '辆', icon: require('@/assets/images/index/total_3.png') },
            ],
            revenueItems: [
                { label: '累计电费总收入', value: '0.00', unit: '元', color: '#52c41a' },
                { label: '累计服务费总收入', value: '0.00', unit: '元', color: '#13c2c2' },
            ],
            trendChartData: {
                labels: [],
                datasets: [
                    {
                        label: '充电量',
                        data: [],
                        borderColor: '#52c41a',
                        backgroundColor: '#52c41a',
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 0,
                        pointHoverRadius: 4
                    },
                    {
                        label: '服务费',
                        data: [],
                        borderColor: '#faad14',
                        backgroundColor: '#faad14',
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 0,
                        pointHoverRadius: 4
                    },
                    {
                        label: '毛利润',
                        data: [],
                        borderColor: '#f5222d',
                        backgroundColor: '#f5222d',
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 0,
                        pointHoverRadius: 4
                    },
                    {
                        label: '单枪充电量',
                        data: [],
                        borderColor: '#722ed1',
                        backgroundColor: '#722ed1',
                        tension: 0.4,
                        borderWidth: 2,
                        pointRadius: 0,
                        pointHoverRadius: 4
                    }
                ]
            },
            trendChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    mode: 'index',
                    intersect: false
                },
                plugins: {
                    legend: {
                        display: true,
                        position: 'top',
                        align: 'start',
                        labels: {
                            boxWidth: 6,
                            boxHeight: 6,
                            usePointStyle: true,
                            pointStyle: 'circle',
                            padding: 20,
                            font: {
                                size: 12
                            },
                            color: '#666'
                        },
                        padding: {
                            left: 50
                        }
                    },
                    layout: {
                    },
                    tooltip: {
                        backgroundColor: 'rgba(255, 255, 255, 0.98)',
                        titleColor: '#333',
                        bodyColor: '#333',
                        borderColor: '#e8e8e8',
                        borderWidth: 1,
                        cornerRadius: 4,
                        padding: 12,
                        titleFont: {
                            size: 12,
                            weight: 'bold'
                        },
                        bodyFont: {
                            size: 11
                        },
                        displayColors: true,
                        boxPadding: 4,
                        callbacks: {
                            title: function(items) {
                                return items[0].label;
                            },
                            label: function(context) {
                                let unit = '';
                                const seriesName = context.dataset.label;
                                if (seriesName === '充电量') unit = ' kWh';
                                else if (seriesName === '服务费') unit = ' 元';
                                else if (seriesName === '毛利润') unit = ' 元';
                                else if (seriesName === '单枪充电量') unit = ' kWh';
                                return seriesName + '：' + context.parsed.y + unit;
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        grid: {
                            color: '#f0f0f0',
                            borderDash: [4, 4]
                        },
                        ticks: {
                            color: '#999',
                            font: {
                                size: 11
                            }
                        },
                        border: {
                            display: false
                        }
                    },
                    y: {
                        grid: {
                            color: '#f0f0f0',
                            borderDash: [4, 4]
                        },
                        ticks: {
                            color: '#999',
                            font: {
                                size: 11
                            }
                        },
                        border: {
                            display: false
                        }
                    }
                }
            },
            pieChart: null,
            pieChartData: {
                labels: ['累计电费总收入', '累计服务费总收入'],
                datasets: [{
                    data: [58.30, 29.20],
                    backgroundColor: ['#1E705C', '#0FBC90'],
                    borderWidth: 0
                }]
            },
            pieChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '0%',
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: true,
                        backgroundColor: 'rgba(255, 255, 255, 0.98)',
                        titleColor: '#333',
                        bodyColor: '#333',
                        borderColor: '#e8e8e8',
                        borderWidth: 1,
                        cornerRadius: 4,
                        padding: 12,
                        callbacks: {
                            label: function(context) {
                                return context.label + ': ' + context.parsed + '%';
                            }
                        }
                    },
                    datalabels: false
                },
                layout: {
                    padding: {
                        top: 40,
                        bottom: 40,
                        left: 150,
                        right: 80
                    }
                },
                clip: false
            },
            pieChartPlugins: [{
                id: 'pieLabels',
                afterDatasetsDraw(chart) {
                    const { ctx, chartArea: { left, right, top, bottom, width, height } } = chart;
                    const centerX = (left + right) / 2;
                    const centerY = (top + bottom) / 2;
                    const radius = Math.min(width, height) / 2;
                    
                    const meta = chart.getDatasetMeta(0);
                    const data = chart.data.datasets[0].data;
                    const labels = chart.data.labels;
                    const total = data.reduce((a, b) => a + b, 0);
                    
                    data.forEach((value, index) => {
                        const arc = meta.data[index];
                        const angle = (arc.startAngle + arc.endAngle) / 2;
                        const percentage = ((value / total) * 100).toFixed(2);
                        
                        // Draw percentage inside the pie
                        const innerRadius = radius * 0.5;
                        const labelX = centerX + Math.cos(angle) * innerRadius;
                        const labelY = centerY + Math.sin(angle) * innerRadius;
                        
                        ctx.save();
                        ctx.fillStyle = '#fff';
                        ctx.font = 'bold 14px sans-serif';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'middle';
                        ctx.fillText(percentage + '%', labelX, labelY);
                        ctx.restore();
                        
                        // Draw guide line and label outside
                        const outerRadius = radius * 0.85;
                        const lineEndRadius = radius * 1.35;
                        
                        const startX = centerX + Math.cos(angle) * outerRadius;
                        const startY = centerY + Math.sin(angle) * outerRadius;
                        
                        const endX = centerX + Math.cos(angle) * lineEndRadius;
                        const endY = centerY + Math.sin(angle) * lineEndRadius;
                        
                        ctx.save();
                        ctx.strokeStyle = arc.options.backgroundColor;
                        ctx.lineWidth = 1.5;
                        
                        // Draw line from pie edge to bend point
                        ctx.beginPath();
                        ctx.moveTo(startX, startY);
                        ctx.lineTo(endX, endY);
                        ctx.stroke();
                        
                        // Draw horizontal line
                        const horizontalLength = 33;
                        const direction = Math.cos(angle) >= 0 ? 1 : -1;
                        ctx.beginPath();
                        ctx.moveTo(endX, endY);
                        ctx.lineTo(endX + horizontalLength * direction, endY);
                        ctx.stroke();
                        
                        // Draw label above the horizontal line
                        ctx.fillStyle = '#333';
                        ctx.font = '12px sans-serif';
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';
                        ctx.fillText(labels[index], endX + (horizontalLength * direction) / 2, endY - 6);
                        
                        ctx.restore();
                    });
                }
            }],
            xAxisData: ['01-08', '01-09', '01-10', '01-11', '01-12', '01-13', '01-14', '01-15', '01-16', '01-17', '01-18', '01-19', '01-20'],
            chartSeries: [
                { name: '充电量', color: '#52c41a', unit: ' kWh', data: [100, 150, 320, 280, 520, 200, 180, 420, 150, 450, 350, 280, 220] },
                { name: '服务费', color: '#faad14', unit: ' 万元', data: [100, 250, 380, 420, 450, 430, 420, 410, 440, 460, 450, 445, 465] },
                { name: '毛利润', color: '#f5222d', unit: '万元', data: [100, 180, 250, 280, 320, 300, 290, 310, 320, 330, 335, 340, 370] },
                { name: '单枪充电量', color: '#722ed1', unit: ' kwh', data: [100, 180, 220, 200, 180, 160, 150, 230, 180, 160, 165, 175, 210] }
            ],
            // 场站数据明细
            stationSearchIds: [],
            stationDateRange: [],
            stationDetailList: [],
            stationDetailTotal: 0,
            stationDetailPage: 1,
            stationDetailPageSize: 10,
            stationDetailLoading: false,
            autoRefreshTimer: null,
            timeInterval: null
        }
    },
    computed: {
        stationList() {
            return (this.$store.state.stationList || []).filter(station => station.state === 2);
        },
        totalRevenue() {
            const elecFee = parseFloat(this.revenueItems[0]?.value.replace(/,/g, '') || 0);
            const svcFee = parseFloat(this.revenueItems[1]?.value.replace(/,/g, '') || 0);
            const total = elecFee + svcFee;
            
            if (total >= 10000) {
                return {
                    value: (total / 10000).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    unit: '万元'
                };
            }
            return {
                value: total.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                unit: '元'
            };
        },
        datePickerType() {
            if (this.trendPeriod === '月') return 'monthrange';
            if (this.trendPeriod === '年') return 'yearrange';
            return 'daterange';
        },
        startPlaceholder() {
            if (this.trendPeriod === '月') return '开始月份';
            if (this.trendPeriod === '年') return '开始年份';
            return '开始日期';
        },
        endPlaceholder() {
            if (this.trendPeriod === '月') return '结束月份';
            if (this.trendPeriod === '年') return '结束年份';
            return '结束日期';
        }
    },
    mounted() {
        this.updateTime();
        this.timeInterval = setInterval(this.updateTime, 1000);
        this.setDefaultDateRange();
        this.setStationDefaultDateRange();
        this.fetchTodayData();
        this.fetchDeviceData();
        this.fetchSumIndicator();
        this.fetchStationDetail();
        // 确保先清除可能存在的旧定时器
        this.startAutoRefresh();
        this.$nextTick(() => {
            setTimeout(() => {
                this.initTrendChart();
                this.initDeviceChart();
            }, 100);
        });
    },
    beforeDestroy() {
        if (this.timeInterval) {
            clearInterval(this.timeInterval);
        }
        if (this.autoRefreshTimer) {
            clearInterval(this.autoRefreshTimer);
        }
        if (this.slowUtilizationChart) {
            this.slowUtilizationChart.dispose();
        }
        if (this.fastUtilizationChart) {
            this.fastUtilizationChart.dispose();
        }
    },
    activated() {
        isTimerRunning = true;
    },
    deactivated() {
        isTimerRunning = false;
    },
    watch: {
        refreshInterval() {
            this.startAutoRefresh();
        },
        todayStation() {
            this.fetchTodayData();
        },
        trendPeriod() {
            this.setDefaultDateRange();
            this.fetchBusinessTrends();
        },
        trendStation() {
            this.fetchBusinessTrends();
        },
        deviceAssetStation() {
            this.fetchDeviceData();
        },
        stationSearchIds() {
            this.stationDetailPage = 1;
            this.fetchStationDetail();
        },
        stationDateRange() {
            this.stationDetailPage = 1;
            this.fetchStationDetail();
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return '-';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        setDefaultDateRange() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            
            if (this.trendPeriod === '日') {
                // 近15天
                const startDate = new Date(now);
                startDate.setDate(startDate.getDate() - 14);
                const startYear = startDate.getFullYear();
                const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
                const startDay = String(startDate.getDate()).padStart(2, '0');
                this.dateRange = [
                    new Date(`${startYear}-${startMonth}-${startDay} 00:00:00`),
                    now
                ];
            } else if (this.trendPeriod === '月') {
                // 当月1号至当前时间
                this.dateRange = [
                    new Date(`${year}-${month}-01 00:00:00`),
                    now
                ];
            } else if (this.trendPeriod === '年') {
                // 当年1月1号至当前时间
                this.dateRange = [
                    new Date(`${year}-01-01 00:00:00`),
                    now
                ];
            }
        },
        setStationDefaultDateRange() {
            const now = new Date();
            const sixMonthsAgo = new Date(now);
            sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
            
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };
            
            this.stationDateRange = [formatDate(sixMonthsAgo), formatDate(now)];
        },
        updateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
            const weekDay = weekDays[now.getDay()];
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            this.currentTime = `${year}-${month}-${day} ${weekDay} ${hours}:${minutes}:${seconds}`;
        },
        async fetchTodayData() {
            try {
                const params = {};
                if (this.todayStation && this.todayStation.length > 0) {
                    params.stationIds = this.todayStation;
                }
                const res = await service.post('bi-server/index/todayData', params);
                if (res.code === 200 && res.data) {
                    const data = res.data;
                    const totalFeeFmt = this.formatLargeNumber(data.totalFee || 0);
                    const totalElecFeeFmt = this.formatLargeNumber(data.totalElecFee || 0);
                    const totalSvcFeeFmt = this.formatLargeNumber(data.totalSvcFee || 0);
                    const totalElecFmt = this.formatLargeNumber(data.totalElec || 0);
                    const singleGunElectFmt = this.formatLargeNumber(data.singleGunElect || 0);
                    const grossProfitFmt = this.formatLargeNumber(data.grossProfit || 0);
                    
                    this.todayStats = [
                        { label: '今日总收入', value: totalFeeFmt.value, unit: totalFeeFmt.unit || '元', trend: this.formatNumber(data.feePercent * 100 || 0), compareValue: this.formatNumber(Math.abs(data.feeDiff) || 0) },
                        { label: '今日电费收入', value: totalElecFeeFmt.value, unit: totalElecFeeFmt.unit || '元', trend: this.formatNumber(data.elecFeePercent * 100 || 0), compareValue: this.formatNumber(Math.abs(data.elecFeeDiff) || 0) },
                        { label: '今日服务费收入', value: totalSvcFeeFmt.value, unit: totalSvcFeeFmt.unit || '元', trend: this.formatNumber(data.svcFeePercent * 100 || 0), compareValue: this.formatNumber(Math.abs(data.svcFeeDiff) || 0) },
                        { label: '今日充电量', value: totalElecFmt.value, unit: totalElecFmt.unit || 'kWh', trend: this.formatNumber(data.elecPercent * 100 || 0), compareValue: this.formatNumber(Math.abs(data.elecDiff) || 0) },
                        { label: '单枪充电量', value: singleGunElectFmt.value, unit: singleGunElectFmt.unit || 'kWh', trend: this.formatNumber(data.singleGunElectPercent * 100 || 0), compareValue: this.formatNumber(Math.abs(data.singleGunElectDiff) || 0) },
                        { label: '今日毛利润', value: grossProfitFmt.value, unit: grossProfitFmt.unit || '元', trend: this.formatNumber(data.grossProfitPercent * 100 || 0), compareValue: this.formatNumber(Math.abs(data.grossProfitDiff) || 0) },
                        { label: '今日充电车次', value: String(data.chargeCount || 0), unit: '辆', trend: this.formatNumber(data.countPercent * 100 || 0), compareValue: this.formatNumber(Math.abs(data.countDiff) || 0) },
                    ];
                }
            } catch (error) {
                console.error('获取今日数据失败:', error);
            }
        },
        async fetchDeviceData() {
            try {
                const params = {};
                if (this.deviceAssetStation && this.deviceAssetStation.length > 0) {
                    params.stationIds = this.deviceAssetStation;
                }
                const res = await service.post('bi-server/index/deviceData', params);
                if (res.code === 200 && res.data) {
                    const data = res.data;
                    const quickData = data.quickData || {};
                    const slowData = data.slowData || {};
                    
                    this.fastDevices = [
                        { label: '充电', count: quickData.chargeCount || 0, percentage: 0, color: '#52c41a' },
                        { label: '空闲', count: quickData.idleCount || 0, percentage: 0, color: '#faad14' },
                        { label: '故障', count: quickData.faultCount || 0, percentage: 0, color: '#f5222d' },
                        { label: '离线', count: quickData.offlineCount || 0, percentage: 0, color: '#d9d9d9' },
                    ];
                    this.slowDevices = [
                        { label: '充电', count: slowData.chargeCount || 0, percentage: 0, color: '#52c41a' },
                        { label: '空闲', count: slowData.idleCount || 0, percentage: 0, color: '#faad14' },
                        { label: '故障', count: slowData.faultCount || 0, percentage: 0, color: '#f5222d' },
                        { label: '离线', count: slowData.offlineCount || 0, percentage: 0, color: '#d9d9d9' },
                    ];
                    this.fastUtilization = quickData.utilizationRate || 0;
                    this.slowUtilization = slowData.utilizationRate || 0;
                    this.fastTotalCount = quickData.connectorCount || 0;
                    this.slowTotalCount = slowData.connectorCount || 0;
                    this.avgUtilizationRate = data.avgUtilizationRate || 0;
                    
                    this.updateDevicePercentages();
                    this.$nextTick(() => {
                        this.initUtilizationCharts();
                    });
                }
            } catch (error) {
                console.error('获取设备数据失败:', error);
            }
        },
        updateDevicePercentages() {
            const totalFast = this.fastTotalCount || this.fastDevices.reduce((sum, item) => sum + item.count, 0);
            if (totalFast > 0) {
                this.fastDevices.forEach(item => {
                    item.percentage = Math.round((item.count / totalFast) * 100);
                });
            }
            
            const totalSlow = this.slowTotalCount || this.slowDevices.reduce((sum, item) => sum + item.count, 0);
            if (totalSlow > 0) {
                this.slowDevices.forEach(item => {
                    item.percentage = Math.round((item.count / totalSlow) * 100);
                });
            }
        },
        formatNumber(num) {
            if (typeof num === 'number') {
                if (Math.abs(num) >= 1000000) {
                    return (num / 10000).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
                return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            return String(num || 0);
        },
        formatLargeNumber(num) {
            if (typeof num === 'number') {
                if (num >= 1000000) {
                    return {
                        value: (num / 10000).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        unit: '万'
                    };
                }
                return {
                    value: num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    unit: ''
                };
            }
            return { value: String(num), unit: '' };
        },
        startAutoRefresh() {
            startGlobalRefresh(() => {
                const currentTab = this.$store.state.TabsActiveName;
                if (currentTab === '/index' || currentTab === '/home') {
                    this.fetchTodayData();
                    this.fetchDeviceData();
                    this.fetchSumIndicator();
                }
            });
        },
        handleRefresh() {
            this.fetchTodayData();
            this.fetchDeviceData();
            this.$message.success('刷新成功');
        },
        handleDeviceAlarmClick(label) {
            if (label === '故障' || label === '离线') {
                let tabPath = '/alarmmanagement';
                this.$store.commit('addHeaderTabs', {
                    topic: '告警管理',
                    path: tabPath
                });
                this.$router.push({ path: tabPath });
            }
        },
        handleStationChange() {
            // 可以在这里处理选择变化后的逻辑
        },
        handleDateRangeChange() {
            this.fetchBusinessTrends();
        },
        getSparklineImage(index) {
            const imageMap = {
                0: require('@/assets/images/index/today_icon1.png'),
                1: require('@/assets/images/index/today_icon2.png'),
                2: require('@/assets/images/index/today_icon3.png'),
                3: require('@/assets/images/index/today_icon4.png'),
                4: require('@/assets/images/index/today_icon5.png'),
                5: require('@/assets/images/index/today_icon6.png'),
                6: require('@/assets/images/index/today_icon7.png'),
            };
            return imageMap[index] || imageMap[0];
        },
        initTrendChart() {
            // vue-chartjs 不需要手动初始化，数据通过 props 传递
            this.fetchBusinessTrends();
        },
        async fetchBusinessTrends() {
            if (this.isFetchingTrends) return;
            this.isFetchingTrends = true;
            
            try {
                const params = {
                    timeType: this.trendPeriod === '日' ? 1 : this.trendPeriod === '月' ? 2 : 3
                };
                
                if (this.dateRange && this.dateRange.length === 2) {
                    const formatDate = (date, isEndTime = false) => {
                        const d = new Date(date);
                        const year = d.getFullYear();
                        const month = String(d.getMonth() + 1).padStart(2, '0');
                        const day = String(d.getDate()).padStart(2, '0');
                        
                        if (this.trendPeriod === '月') {
                            // 月选择器返回的是月份的第一天
                            if (isEndTime) {
                                // 月末最后一天
                                const lastDay = new Date(year, d.getMonth() + 1, 0).getDate();
                                return `${year}-${month}-${String(lastDay).padStart(2, '0')} 23:59:59`;
                            }
                            return `${year}-${month}-01 00:00:00`;
                        }
                        
                        if (this.trendPeriod === '年') {
                            if (isEndTime) {
                                return `${year}-12-31 23:59:59`;
                            }
                            return `${year}-01-01 00:00:00`;
                        }
                        
                        // 日选择器
                        if (isEndTime) {
                            return `${year}-${month}-${day} 23:59:59`;
                        }
                        const hours = String(d.getHours()).padStart(2, '0');
                        const minutes = String(d.getMinutes()).padStart(2, '0');
                        const seconds = String(d.getSeconds()).padStart(2, '0');
                        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                    };
                    params.startTime = formatDate(this.dateRange[0]);
                    params.endTime = formatDate(this.dateRange[1], true);
                }
                
                if (this.trendStation && this.trendStation.length > 0) {
                    params.stationIds = this.trendStation;
                }
                
                const res = await service.post('bi-server/index/businessTrends', params);
                if (res.code === 200 && res.data) {
                    const data = res.data;
                    const trendElecFmt = this.formatLargeNumber(data.totalElect || 0);
                    const trendSvcFeeFmt = this.formatLargeNumber(data.totalSvcFee || 0);
                    const trendGrossProfitFmt = this.formatLargeNumber(data.totalProfit || 0);
                    
                    this.trendMetrics = [
                        { label: '合计充电量', value: trendElecFmt.value, unit: trendElecFmt.unit || 'kwh', color: '#52c41a' },
                        { label: '合计服务费', value: trendSvcFeeFmt.value, unit: trendSvcFeeFmt.unit || '元', color: '#faad14' },
                        { label: '合计毛利润', value: trendGrossProfitFmt.value, unit: trendGrossProfitFmt.unit || '元', color: '#f5222d' },
                    ];
                    
                    if (data.detailList && data.detailList.length > 0) {
                        const detailList = data.detailList;
                        const labels = detailList.map(item => item.groupTime);
                        const elecData = detailList.map(item => item.totalElec || 0);
                        const svcFeeData = detailList.map(item => item.totalSvcFee || 0);
                        const grossProfitData = detailList.map(item => item.totalProfit || 0);
                        const avgPileElecData = detailList.map(item => item.avgPileElec || 0);
                        
                        this.trendChartData = {
                            labels: labels,
                            datasets: [
                                { ...this.trendChartData.datasets[0], data: elecData },
                                { ...this.trendChartData.datasets[1], data: svcFeeData },
                                { ...this.trendChartData.datasets[2], data: grossProfitData },
                                { ...this.trendChartData.datasets[3], data: avgPileElecData }
                            ]
                        };
                    } else {
                        this.trendChartData = {
                            labels: [],
                            datasets: [
                                { ...this.trendChartData.datasets[0], data: [] },
                                { ...this.trendChartData.datasets[1], data: [] },
                                { ...this.trendChartData.datasets[2], data: [] },
                                { ...this.trendChartData.datasets[3], data: [] }
                            ]
                        };
                    }
                }
            } catch (error) {
                console.error('获取经营趋势数据失败:', error);
            } finally {
                this.isFetchingTrends = false;
            }
        },
        async fetchSumIndicator() {
            try {
                const res = await service.post('bi-server/index/sumIndicator', {});
                if (res.code === 200 && res.data) {
                    const data = res.data;
                    
                    const totalElecFmt = this.formatLargeNumber(data.totalElec || 0);
                    const profitFmt = this.formatLargeNumber(data.profit || 0);
                    const elecFeeFmt = this.formatLargeNumber(data.totalElecFee || 0);
                    const svcFeeFmt = this.formatLargeNumber(data.totalSvcFee || 0);
                    
                    this.historyMetrics = [
                        { label: '全站累计总充电量', value: totalElecFmt.value, unit: totalElecFmt.unit || 'kwh', icon: require('@/assets/images/index/total_1.png') },
                        { label: '全站累计毛利润', value: profitFmt.value, unit: profitFmt.unit || '元', icon: require('@/assets/images/index/total_2.png') },
                        { label: '全站累计充电总车次', value: Math.round(data.chargeCount || 0).toLocaleString('zh-CN'), unit: '辆', icon: require('@/assets/images/index/total_3.png') },
                    ];
                    this.revenueItems = [
                        { label: '累计电费总收入', value: elecFeeFmt.value, unit: elecFeeFmt.unit || '元', color: '#52c41a' },
                        { label: '累计服务费总收入', value: svcFeeFmt.value, unit: svcFeeFmt.unit || '元', color: '#13c2c2' },
                    ];
                    
                    const total = (data.totalElecFee || 0) + (data.totalSvcFee || 0);
                    const elecPercent = total > 0 ? ((data.totalElecFee || 0) / total * 100).toFixed(2) : 0;
                    const svcPercent = total > 0 ? ((data.totalSvcFee || 0) / total * 100).toFixed(2) : 0;
                    this.pieChartData = {
                        labels: ['累计电费总收入', '累计服务费总收入'],
                        datasets: [{
                            data: [parseFloat(elecPercent), parseFloat(svcPercent)],
                            backgroundColor: ['#1E705C', '#0FBC90'],
                            borderWidth: 0
                        }]
                    };
                }
            } catch (error) {
                console.error('获取累计历史指标数据失败:', error);
            }
        },
        initDeviceChart() {
            const chartDom = this.$refs.deviceChart;
            if (!chartDom) return;
            this.deviceChart = this.$echarts.init(chartDom);
            const option = {
                series: [{
                    type: 'gauge',
                    startAngle: 200,
                    endAngle: -20,
                    min: 0,
                    max: 100,
                    splitNumber: 10,
                    radius: '90%',
                    center: ['50%', '55%'],
                    progress: {
                        show: true,
                        width: 12,
                        itemStyle: { color: '#52c41a' }
                    },
                    axisLine: {
                        lineStyle: { width: 12, color: [[1, '#e8e8e8']] }
                    },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    axisLabel: { show: false },
                    pointer: { show: false },
                    anchor: { show: false },
                    title: { show: false },
                    detail: {
                        valueAnimation: true,
                        fontSize: 20,
                        fontWeight: 'bold',
                        offsetCenter: [0, '0%'],
                        formatter: '{value}%',
                        color: '#333'
                    },
                    data: [{ value: 80 }]
                }]
            };
            this.deviceChart.setOption(option);
        },
        initUtilizationCharts() {
            this.initSingleUtilizationChart('slowUtilizationChart', this.slowUtilization);
            this.initSingleUtilizationChart('fastUtilizationChart', this.fastUtilization);
        },
        initSingleUtilizationChart(refName, value) {
            const chartDom = this.$refs[refName];
            if (!chartDom) return;
            
            let chart = this[refName];
            if (!chart) {
                chart = this.$echarts.init(chartDom);
                this[refName] = chart;
            }
            
            const option = {
                graphic: {
                    type: 'circle',
                    left: 'center',
                    top: 'middle',
                    shape: { r: 26 },
                    style: { fill: '#34495e' }
                },
                series: [
                    {
                        type: 'gauge',
                        startAngle: 90,
                        endAngle: -270,
                        min: 0,
                        max: 100,
                        radius: '95%',
                        center: ['50%', '50%'],
                        axisLine: {
                            lineStyle: { width: 6, color: [[1, '#34495e']] }
                        },
                        progress: {
                            show: true,
                            width: 6,
                            roundCap: true,
                            itemStyle: { color: '#00d18b' }
                        },
                        pointer: { show: false },
                        axisTick: { show: false },
                        splitLine: { show: false },
                        axisLabel: { show: false },
                        detail: {
                            valueAnimation: true,
                            formatter: '{value}%',
                            color: '#ffffff',
                            fontSize: 12,
                            fontWeight: 500,
                            offsetCenter: [0, 0],
                            backgroundColor: 'transparent'
                        },
                        data: [
                            {
                                value: value
                            }
                        ]
                    }
                ]
            };
            chart.setOption(option);
        },
        async fetchStationDetail() {
            this.stationDetailLoading = true;
            try {
                const params = {
                    pageNum: this.stationDetailPage,
                    pageSize: this.stationDetailPageSize
                };
                
                if (this.stationSearchIds && this.stationSearchIds.length > 0) {
                    params.stationIds = this.stationSearchIds;
                }
                
                if (this.stationDateRange && this.stationDateRange.length === 2) {
                    params.startTime = this.stationDateRange[0] + ' 00:00:00';
                    params.endTime = this.stationDateRange[1] + ' 23:59:59';
                }
                
                const res = await service.post('bi-server/index/stationDataDetail', params);
                if (res.code === 200 && res.data) {
                    this.stationDetailList = res.data.records || [];
                    this.stationDetailTotal = res.data.total || 0;
                }
            } catch (error) {
                console.error('获取场站数据明细失败:', error);
            } finally {
                this.stationDetailLoading = false;
            }
        },
        handleStationSearch() {
            this.stationDetailPage = 1;
            this.fetchStationDetail();
        },
        handleStationPageChange(page) {
            this.stationDetailPage = page;
            this.fetchStationDetail();
        },
        handleStationSizeChange(size) {
            this.stationDetailPageSize = size;
            this.stationDetailPage = 1;
            this.fetchStationDetail();
        }
    }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
    padding: 16px;
    background: #f5f7fa;
    min-height: 100vh;
}

.main-layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
}

.left-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.right-column {
    display: flex;
    flex-direction: column;
    .device-assets {
        flex: 1;
        height: 100%;
    }
}

.header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
        margin: 0;
    }
    .current-time {
        font-size: 13px;
        color: #909399;
        white-space: nowrap;
    }
    .header-right {
        display: flex;
        align-items: center;
        gap: 16px;
        white-space: nowrap;
    }
    .refresh-wrapper {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-left: 12px;
        padding: 4px 8px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        white-space: nowrap;
    }
    .refresh-icon {
        font-size: 16px;
        color: #909399;
        cursor: pointer;
        transition: color 0.3s;
        &:hover {
            color: #409eff;
        }
    }
}

:deep(.interval-selector) {
    width: 70px;
    .el-input__wrapper {
        box-shadow: none !important;
        border: none !important;
        background-color: transparent !important;
        padding: 0 !important;
    }
    .el-select__wrapper {
        box-shadow: none !important;
        padding: 0 !important;
    }
    .el-select__selection {
        min-height: auto !important;
    }
    .el-select__placeholder,
    .el-select__selected-item {
        font-size: 13px !important;
        color: #909399 !important;
    }
}

.stats-cards {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 16px;
}

.stat-card {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    .stat-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .stat-left {
        flex: 1;
    }
    .stat-label {
        font-size: 13px;
        color: #909399;
        margin-bottom: 8px;
    }
    .stat-value {
        margin-bottom: 8px;
        .value-number {
            font-size: 24px;
            font-weight: bold;
            color: #303133;
        }
        .value-unit {
            font-size: 13px;
            color: #909399;
            margin-left: 4px;
        }
    }
    .stat-footer {
        display: flex;
        align-items: center;
        gap: 8px;
        .trend-badge {
            font-size: 12px;
            padding: 2px 6px;
            border-radius: 2px;
            &.trend-up {
                color: #FD625E;
                background: rgba(253, 98, 94, 0.2);
            }
            &.trend-down {
                color: #19C499;
                background: rgba(25, 196, 153, 0.2);
            }
        }
        .compare-value {
            font-size: 12px;
            color: #909399;
        }
    }
    .stat-right {
        flex-shrink: 0;
        .sparkline-image {
            width: 32px;
            height: 32px;
        }
    }
}

.trend-analysis {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    flex: 1;
    overflow: visible;
    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        .section-title {
            font-size: 20px;
            font-weight: 600;
            color: #303133;
            margin: 0;
        }
        .section-controls {
            display: flex;
            align-items: center;
            gap: 12px;
            .station-search {
                :deep(.el-input__wrapper) {
                    box-shadow: none;
                    background: #f5f7fa;
                    border-radius: 4px;
                    height: 32px;
                    padding: 0 12px;
                }
            }
            .period-radio {
                background: #f5f7fa;
                border-radius: 4px;
                padding: 2px;
                height: 32px;
                display: flex;
                align-items: center;
                :deep(.el-radio-button__inner) {
                    background: transparent;
                    border: none;
                    box-shadow: none;
                    border-radius: 2px;
                    padding: 4px 16px;
                    height: 28px;
                    line-height: 20px;
                }
                :deep(.el-radio-button__original-radio:checked + .el-radio-button__inner) {
                    background: #fff;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    color: #409eff;
                }
            }
            .date-range-picker {
                width: 280px !important;
                max-width: 280px !important;
                height: 32px !important;
                min-height: 32px !important;
                :deep(.el-input) {
                    height: 32px !important;
                }
                :deep(.el-input__wrapper) {
                    box-shadow: none;
                    background: #f5f7fa;
                    border-radius: 4px;
                    height: 32px !important;
                    min-height: 32px !important;
                    padding: 0 8px;
                    display: flex;
                    align-items: center;
                }
                :deep(.el-range-editor) {
                    height: 32px !important;
                    min-height: 32px !important;
                    padding: 0 4px;
                }
                :deep(.el-range-input) {
                    height: 32px !important;
                    line-height: 32px !important;
                    font-size: 14px;
                }
                :deep(.el-range-separator) {
                    height: 32px !important;
                    line-height: 32px !important;
                    font-size: 14px;
                    padding: 0 4px;
                }
                :deep(.el-range__icon) {
                    height: 32px !important;
                    line-height: 32px !important;
                    font-size: 14px;
                }
                :deep(.el-range__close-icon) {
                    height: 32px !important;
                    line-height: 32px !important;
                }
            }
        }
    }
    .trend-content {
        display: flex;
        gap: 16px;
        overflow: visible;
    }
    .trend-left {
        width: 180px;
        flex-shrink: 0;
        padding-top: 18px;
    }
    .trend-metric {
        margin-bottom: 30px;
        .metric-label-row {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-bottom: 8px;
            .metric-dot {
                width: 10px;
                height: 10px;
                border-radius: 50%;
            }
            .metric-label {
                font-size: 13px;
                color: #606266;
            }
        }
        .metric-value-row {
            margin-bottom: 8px;
            .metric-number {
                font-size: 28px;
                font-weight: bold;
                color: #303133;
            }
            .metric-unit {
                font-size: 13px;
                color: #909399;
                margin-left: 4px;
            }
        }
        .metric-footer {
            display: flex;
            align-items: center;
            gap: 10px;
            .trend-badge {
                font-size: 13px;
                padding: 2px 8px;
                border-radius: 3px;
                &.trend-up {
                    color: #FD625E;
                    background: rgba(253, 98, 94, 0.2);
                }
                &.trend-down {
                    color: #19C499;
                    background: rgba(25, 196, 153, 0.2);
                }
            }
            .compare-value {
                font-size: 13px;
                color: #909399;
            }
        }
    }
    .trend-right {
        flex: 1;
    }
    .trend-chart-container {
        width: 100%;
        height: 350px;
        position: relative;
    }
    .trend-chart-container canvas {
        width: 100% !important;
        height: 100% !important;
    }
    
    .trend-chart-container .chartjs-legend ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
    }
    
    .trend-chart-container .chartjs-legend li {
        display: flex;
        align-items: center;
        margin-right: 20px;
        margin-bottom: 4px;
    }
    
    .trend-chart-container .chartjs-legend li span {
        display: inline-block;
        width: 12px !important;
        height: 12px !important;
        min-width: 12px !important;
        min-height: 12px !important;
        margin-right: 8px !important;
        border-radius: 50% !important;
    }
}

.device-assets {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
}

.device-assets-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    .section-title {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
        margin: 0;
    }
}

.device-assets-content {
    display: flex;
    gap: 16px;
    align-items: stretch;
}

.asset-left-panel {
    min-width: 390px;
    background: url('@/assets/images/index/device_assets_bg.png') no-repeat center center;
    background-size: cover;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    gap: 20px;
    .pile-icon-wrapper {
        flex-shrink: 0;
        .pile-icon {
            width: 100px;
            height: 100px;
            object-fit: contain;
        }
    }
    .gauge-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        .utilization-gauge {
            position: relative;
            width: 120px;
            height: 70px;
            .gauge-svg {
                width: 100%;
                height: 100%;
            }
            .utilization-text {
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                font-size: 20px;
                font-weight: bold;
                color: #0FBC90;
            }
        }
        .utilization-label {
            font-size: 13px;
            color: #0FBC90;
        }
    }
}

.asset-center-panel,
.asset-right-panel {
    flex: 1;
    background: #f5f7fa;
    border-radius: 8px;
    padding: 16px;
    .panel-body {
        display: flex;
        gap: 16px;
        align-items: center;
        justify-content: center;
        height: 100%;
        min-height: 140px;
        .panel-left {
            flex-shrink: 0;
            width: 100px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            .panel-title {
                font-size: 13px;
                color: #606266;
            }
            .panel-total {
                .total-number {
                    font-size: 28px;
                    font-weight: bold;
                    color: #303133;
                }
                .total-unit {
                    font-size: 14px;
                    color: #909399;
                    margin-left: 4px;
                }
            }
        }
        .divider-line {
            width: 10px;
            height: 100%;
            max-height: 120px;
            object-fit: contain;
            flex-shrink: 0;
        }
        .panel-right {
            flex: 1;
            .device-stats-grid {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 22px 20px;
                .stat-row {
                    &.clickable {
                        cursor: pointer;
                        &:hover {
                            opacity: 0.8;
                        }
                    }
                    .stat-info {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 4px;
                        .stat-label {
                            font-size: 13px;
                            color: #606266;
                        }
                        .stat-percent {
                            font-size: 13px;
                            color: #909399;
                        }
                    }
                    .stat-progress {
                        :deep(.el-progress-bar__outer) {
                            height: 8px !important;
                            border-radius: 4px;
                        }
                        :deep(.el-progress-bar__inner) {
                            border-radius: 4px;
                        }
                    }
                }
            }
        }
        .utilization-gauge-chart {
            width: 58px;
            height: 58px;
        }
        .circle-label {
            font-size: 12px;
            color: #909399;
            white-space: nowrap;
            text-align: center;
            display: block;
            margin-bottom: 4px;
        }
    }
}

.history-section-wrapper {
    background: transparent;
    border-radius: 8px;
    margin-bottom: 16px;
    overflow: visible;
}

.history-section-header {
    background: #fff;
    border-radius: 8px;
    padding: 17px 20px;
    margin-bottom: 8px;
    .section-title {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
        margin: 0;
    }
}

.history-section-card {
    background: #fff;
    border-radius: 8px;
    padding: 12px 16px;
    overflow: visible;
    height: 260px;
}

.history-content {
    display: flex;
    gap: 20px;
    padding-top: 12px;
    overflow: visible;
    height: calc(100% - 24px);
}

.history-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    gap: 0;
}

.history-metrics-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.metrics-divider {
    height: 1px;
    background-color: #e8e8e8;
    margin: 16px 0;
}

.history-metric {
    display: flex;
    align-items: center;
    gap: 12px;
    .metric-icon-img {
        width: 52px;
        height: 52px;
        object-fit: contain;
    }
    .metric-info {
        .metric-label {
            font-size: 13px;
            color: #606266;
            margin-bottom: 6px;
        }
        .metric-value {
            display: flex;
            align-items: baseline;
            .value-number {
                font-size: 24px;
                font-weight: bold;
                color: #303133;
            }
            .value-unit {
                font-size: 13px;
                color: #909399;
                margin-left: 4px;
            }
        }
    }
}

.history-right {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 60px;
    border-left: 1px solid #e8e8e8;
    padding-left: 20px;
    overflow: visible;
}

.pie-chart-section {
    flex-shrink: 0;
    position: relative;
    overflow: visible;
}

.pie-chart-title {
    position: absolute;
    top: calc(50% - 90px);
    left: 0;
    transform: translateY(-50%);
    font-size: 14px;
    color: #303133;
    font-weight: 600;
    z-index: 10;
}

.pie-chart-container {
    width: 380px;
    height: 380px;
    position: relative;
    overflow: visible;
    margin-left: -30px;
}

.pie-chart-container canvas {
    width: 100% !important;
    height: 100% !important;
    overflow: visible !important;
}

.revenue-stats {
    flex: 1;
    .revenue-total {
        margin-bottom: 16px;
        .total-label {
            font-size: 14px;
            color: #303133;
            font-weight: 600;
            margin-bottom: 6px;
        }
        .total-value {
            display: flex;
            align-items: baseline;
            .value-number {
                font-size: 28px;
                font-weight: bold;
                color: #303133;
            }
            .value-unit {
                font-size: 13px;
                color: #909399;
                margin-left: 4px;
            }
        }
    }
    .revenue-items {
        .revenue-item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 12px;
            .item-left {
                display: flex;
                align-items: center;
                margin-bottom: 4px;
            }
            .item-dot {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 8px;
                flex-shrink: 0;
            }
            .item-label {
                font-size: 13px;
                color: #606266;
            }
            .item-value {
                font-size: 16px;
                color: #303133;
                font-weight: 600;
            }
        }
    }
}

.station-detail-section {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
    .section-header {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .section-title {
            font-size: 20px;
            font-weight: 600;
            color: #303133;
            margin: 0;
            position: relative;
            padding-left: 12px;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 16px;
                background: #409eff;
                border-radius: 2px;
            }
        }
        .station-count {
            font-size: 13px;
            color: #909399;
            margin-left: 12px;
        }
        .search-wrapper {
            margin-left: auto;
            display: flex;
            align-items: center;
            gap: 12px;
            .station-search {
                width: 220px;
            }
            .station-date-picker {
                width: 280px;
            }
        }
    }
    .station-table-wrapper {
        .rank-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            font-size: 12px;
            font-weight: 600;
            color: #909399;
            background: #f5f7fa;
            &.rank-1 {
                background: #f5a623;
                color: #fff;
            }
            &.rank-2 {
                background: #a0a0a0;
                color: #fff;
            }
            &.rank-3 {
                background: #cd7f32;
                color: #fff;
            }
        }
        .revenue-text {
            font-size: 14px;
            font-weight: 600;
            color: #52c41a;
            &.total-revenue {
                color: #1890ff;
            }
        }
        .pagination-wrapper {
            display: flex;
            justify-content: flex-end;
            margin-top: 16px;
        }
    }
}
</style>